import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'

import { setCockpitRevenueAndSobView } from '../../../../model'
import { CockpitShowQuota } from '../../../cockpitShowQuota/CockpitShowQuota'
import { CockpitFilterSummary } from '../../../components/cockpitFilterSummary'
import { CockpitTileTitle } from '../../../components/cockpitTileTitle'
import { CockpitTableViewSwitch } from '../cockpitTableViewSwitch/CockpitTableViewSwitch'

type CockpitRevenueAndSobTitleProps = {
  title: string
  expanded: boolean
  onToggle: () => void
  /** The single-partner cockpit keeps Show quota here, beside the numbers it changes; the
   *  manager cockpit keeps it in its own settings panel. */
  withQuota?: boolean
  /** Scores the view switch's Plan Quality tab as the manager cockpit's own table shows it. */
  isManagerCockpitMode?: boolean
  /** `data-tour-id` for the view switch. Both cockpits open this tile, and each tour targets the
   *  switch by its own id. */
  viewSwitchTourId?: string
}

export const CockpitRevenueAndSobTitle = ({
  title,
  expanded,
  onToggle,
  withQuota = false,
  isManagerCockpitMode = false,
  viewSwitchTourId,
}: CockpitRevenueAndSobTitleProps) => {
  const dispatch = useAppDispatch()

  /** Expanding from the title always means the Financial & SOB table. Only the collapsed
   *  tile's score asks for the quality view, so reset what a previous click may have left. */
  const handleToggle = () => {
    if (!expanded) {
      dispatch(setCockpitRevenueAndSobView('detail'))
    }

    onToggle()
  }

  return (
    <CockpitTileTitle
      title={title}
      expanded={expanded}
      onToggle={handleToggle}
      actions={
        <>
          {/* The views are the expanded tile's own: collapsed, the tile shows its summary only. */}
          {expanded && (
            <CockpitTableViewSwitch
              isManagerCockpitMode={isManagerCockpitMode}
              tourId={viewSwitchTourId}
            />
          )}
          {withQuota && <CockpitShowQuota compact />}
        </>
      }
    >
      <CockpitFilterSummary
        expanded={expanded}
        bordered={false}
        offering
        category
        period
        metric
        currency
      />
    </CockpitTileTitle>
  )
}

CockpitRevenueAndSobTitle.displayName = 'CockpitRevenueAndSobTitle'
